import _classCallCheck from "C:\\wamp64\\www\\aiscan\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\wamp64\\www\\aiscan\\node_modules\\@babel\\runtime/helpers/esm/createClass";
// @ts-ignore
import { combineReducers as _combineReducers } from "redux";
import { ReducerBuilder } from "./ReducerBuilder";
export var ReduxStorageUtils =
/*#__PURE__*/
function () {
  function ReduxStorageUtils() {
    _classCallCheck(this, ReduxStorageUtils);
  }

  _createClass(ReduxStorageUtils, null, [{
    key: "initialize",
    value: function initialize(storage) {
      this.storage = storage;
      return storage;
    }
  }, {
    key: "getStorage",
    value: function getStorage() {
      return this.storage;
    }
  }, {
    key: "dispatch",
    value: function dispatch(action) {
      ReduxStorageUtils.getStorage().dispatch(action);
    }
  }, {
    key: "connectAction",
    value: function connectAction(action) {
      return function () {
        var funcResult = action.apply(void 0, arguments);
        if (isFunction(funcResult)) funcResult(ReduxStorageUtils.getStorage().dispatch);else ReduxStorageUtils.getStorage().dispatch(funcResult);
      };
    }
  }, {
    key: "getState",
    value: function getState(reducer) {
      return ReduxStorageUtils.getStorage().getState()[reducer.reactotronKey];
    }
  }, {
    key: "combineReducers",
    value: function combineReducers(reducers) {
      var resultObj = {};
      reducers.forEach(function (reducer) {
        return resultObj[reducer["reactotronKey"]] = reducer;
      });
      return _combineReducers(resultObj);
    }
  }, {
    key: "sendResetActionToAllReducers",
    value: function sendResetActionToAllReducers() {
      this.dispatch(ReducerBuilder.EVENT_ACTION_RESET_ALL_REDUCERS_TO_INITIAL_STATE);
    }
  }]);

  return ReduxStorageUtils;
}();

function isFunction(functionToCheck) {
  return functionToCheck && {}.toString.call(functionToCheck) === "[object Function]";
}